import React from "react";
import * as S from "./styles";

const ModalFooter = ({ children }) => {
  return <S.StyledFooter>{children}</S.StyledFooter>;
};

export default ModalFooter;
